var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseView',[_c('template',{slot:"status"},[_c('formatter',{attrs:{"text":_vm.$t('Subscription will renew on {date}')}},[_c('template',{slot:"date"},[_vm._v(_vm._s(_vm._f("date")(_vm.subscription.expirationDate)))])],2)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }